/*
 * @Author: jiahuacui
 * @Date: 2018-08-09 14:31:10
 * @LastEditors: jiahuacui
 * @LastEditTime: 2018-08-08 14:31:10
 * @Description: 
 */
<!-- bom关联组件 
  module: 模块名
  item: 绑定对象
  form: form表单数据对象
-->
<template>
  <div class="item-select" :class="{'disable': item.nonEditable === 1}">
    <el-autocomplete
      v-if="!form[item.attr].id && (JSON.stringify(form[item.attr]) === '{}' || form[item.attr].length === 0)"
      v-model="itemValue"
      :fetch-suggestions="querySearchAsync"
      :placeholder="'请点击“选择”添加'"
      @select="selectedChecked">
    </el-autocomplete>
    <span class="item" v-if="form && form[item.attr].id" >
      <span class="text">{{form[item.attr].value}}</span>
      <i class="del el-icon-close" @click="del()"></i>
    </span>
    <el-button type="text" class="select-btn" @click="handleSelect(module)">选择</el-button>
    <transition name="slide" v-if="showAssociated">
      <bom-bill
        ref="bomBill"
        :module="module"
        :attrValue="formatAttrValue(form[item.attr])"
        @emitObj="emitObj"
        @close="showAssociated = false">
      </bom-bill>
    </transition>
    <transition name="fade">
      <div class="detail-bg" v-if="showAssociated" @click.stop="detailShow=false"></div>
    </transition>
  </div>
</template>
<script>
import * as api from 'src/api'
import { mapActions } from 'vuex'
import { LS } from 'assets/js/storage'
import bomBill from 'components/fieldtype/product-manage/bom-bill.vue' // bom

export default {
  props: {
    module: {
      type: String
    },
    item: {
      type: Object,
      default: () => {}
    },
    form: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      showAssociated: false,
      addnewShow: false,
      repeatListShow: false,
      addnewProp: {},
      itemValue: '',
      timeout: null, // 计时器
      url: '', // url
      dataMap: {
        [this.module]: '/bomBill/getBomBillList.html'
      }
    }
  },
  created () {
    this.url = this.dataMap[this.module]
  },
  computed: {
  },
  methods: {
    ...mapActions([
      'setAttr'
    ]),
    handleSelect () {
      this.repeatListShow = false
      this.showAssociated = true
    },

    // bom下拉搜索
    querySearchAsync (queryString, cb) {
      clearTimeout(this.timeout)
      queryString = queryString.trim()
      if (!queryString) {
        cb([])
        return
      }
      this.timeout = setTimeout(() => {
        let params = {
          sheetNo: queryString
        }
        if (this.module === 'productionOrder') {
          let pageType = this.$route.query.type // 一键生产
          if (pageType === 'waitProduce') {
            let productArray = this.$route.params.productArray || LS.get('VUE-productArray')
            productArray.map((item) => {
              params.productId = item.productId
            })
          }
        }
        if (this.customerId) {
          params.customerId = this.customerId
        }
        api.post(this.url, params, (data) => {
          cb(data.result)
        })
      }, 3000 * Math.random())
    },
    selectedChecked (item) {
      this.form[this.item.attr] = {
        id: item.id,
        value: item.value,
        version: item.version,
        sheetNo: item.sheetNo
      }
      this.setAttr(this.item.attr)
      this.repeatListShow = false
      this.$emit('emitObj', this.form[this.item.attr])
    },
    emitObj (data) {
      let emitData = ''
      if (this.form && data.length > 0) {
        if (data[0].id) {
          emitData = data[0]
        } else {
          emitData = ''
        }
        this.form[this.item.attr] = emitData
      }
      this.showAssociated = false
      this.setAttr(this.item.attr)
      this.$emit('emitObj', emitData)
    },
    refresh () {
      if (this.$refs.bomBill) {
        this.$refs.bomBill.getUserList()
      }
    },
    // 删除已选项
    del (i) {
      this.form[this.item.attr] = ''
      this.itemValue = ''
      this.$emit('emitObj', this.form[this.item.attr])
      this.setAttr(this.item.attr)
    },
    formatAttrValue (value) {
      return value ? [value] : []
    }
  },
  components: {
    bomBill
  }
}
</script>
<style lang="less" scoped>
@import '../../../assets/less/remote-select.less';
  .item-select {
    .select-btn {
      right: 0px;
      background: #fff;
      padding-right: 10px;
      padding-left: 10px;
    }
    .detail-bg {
      top: 0;
    }
    &.disable {
      background-color: #eef1f6;
      border: 1px solid #d1dbe5;
      color: #bbb;
      .select-btn {
        background-color: transparent;
      }
      &:after {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        opacity: 0;
        cursor: not-allowed;
      }
    }
  }
  .repeat-list {
    position: absolute;
    width: 250px;
    max-height: 300px;
    background-color: #fff;
    z-index: 100;
    overflow: auto;
    box-shadow: 0 0 4px 0 rgba(137, 137, 137, 0.5);
    left: 2px;
    top: 40px;
    .title {
      font-size: 14px;
      line-height: 32px;
      border-bottom: 1px solid #ededed;
      padding-left: 10px;
    }
    .repeat-item {
      cursor: pointer;
      line-height: 28px;
      padding: 0 10px;
      color: #888;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
</style>
<style lang="less">
  .remote-select {
    .el-form-item__content {
      overflow: hidden;
    }
  }
  .item-select {
    .el-autocomplete {
      width: 100%;
      .el-input.is-disabled .el-input__inner {
        background-color: #fff;
      }
    }
    &.disable {
      .el-input__inner {
        background-color: transparent;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// bom-field.vue?0f45d43c